/**
 * Доля закрытых вложенных задач (3.8.5).
 *
 * Живёт отдельным файлом, потому что нужна в трёх местах сразу: в списке
 * проектов, в самом проекте и в разделе связей карточки.
 */

/*
 * Число, а не только полоска: «3/8» отвечает на вопрос точно, а полоска — лишь
 * приблизительно, и в списке проектов важнее первое.
 */
export function ProgressCount({
  progress,
}: {
  progress: { done: number; total: number };
}): React.ReactElement {
  const percent = progress.total === 0 ? 0 : Math.round((progress.done / progress.total) * 100);

  return (
    <span className="clbadge">
      <span className="clbadge__count">
        {progress.done}/{progress.total}
      </span>
      <span
        className="progress"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={progress.total}
        aria-valuenow={progress.done}
        aria-label={`Проект: закрыто ${String(progress.done)} из ${String(progress.total)}`}
      >
        <i style={{ width: `${String(percent)}%` }} />
      </span>
    </span>
  );
}
